import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiBellAlert } from "react-icons/hi2";
import './Header.css';
import NotificationDropdown from './NotificationDropdown';
import edfocilogo from "../../../assets/images/logo.png";
import edsiderlogo from "../../../assets/images/edsiderlogo.png";
import teacherImg from "../../../assets/images/teacher.png";
import studentImg from "../../../assets/images/student.png";
import parentImg from "../../../assets/images/parent.png";
import adminImg from "../../../assets/images/admin.png";
import cmclogo from "../../../assets/images/mid.png";
import RAlogo from "../../../assets/images/royal-logo.png";
import CGClogo from "../../../assets/images/cgc-logo.png";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const Header = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isAdmin] = useState(sessionStorage.getItem("userType") === "admin");
  const [isTeacher] = useState(sessionStorage.getItem("userType") === "teacher");
  const [isStudent] = useState(sessionStorage.getItem("userType") === "student");
  const [isParent] = useState(sessionStorage.getItem("userType") === "parent");

  //Creates the label for the button of aside menu
  const headerLabelMaker = () => {
    const sessionUserName = sessionStorage.getItem("username");

    if (sessionUserName) {
      const names = sessionUserName.split(" ");
      const initials = names.map((name) => {
        if (name.length > 0) {
          return name[0].toUpperCase();
        } else {
          return ""; // Handle empty names if necessary
        }
      });
      const result = initials.join("");
      return result;
    } else {
      return ""; // Handle the case where sessionUserName is not available
    }
  };

  const toggleNotifications = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const customer = getCustomerFeatureFlag();
  let logo, logoStyle;
  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
      logo = edsiderlogo;
      logoStyle = { width: "140px", height: "auto" };
      break;
    case customerConstants.EXO_CUSTOMER2:
      logo = cmclogo;
      logoStyle = { width: "140px", height: "auto" };
      break;
    case customerConstants.EDF_CUSTOMER2:
      logo = RAlogo;
      logoStyle = { width: "40px", height: "auto" };
      break;
    case customerConstants.EDF_CUSTOMER3:
      logo = CGClogo;
      logoStyle = { width: "40px", height: "auto" };
      break;
    default:
      logo = edfocilogo;
      logoStyle = { width: "140px", height: "auto" };
      break;
  }

  return (
    <div id="kt_header" className="header header-fixed">
      {/* begin::Container */}
      <div className="container-fluid d-flex align-items-stretch justify-content-between">
        {/* begin::Header Menu Wrapper */}
        <div
          className="header-menu-wrapper header-menu-wrapper-left"
          id="kt_header_menu_wrapper"
        >
          {/* begin::Info */}
          <div className="d-flex align-items-center flex-wrap mr-0">
            {/* begin::Actions */}
            {/* <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"></div> */}
            {/* <span className="text-muted font-weight-bold mr-4"></span> */}
            <div className="brand-logo">
              {/* <img alt="Logo" className="logo" src="../../../../public/assets/media/logos/logo-light.png" /> */}
              <img
                alt="Logo"
                className={`logo brand-logo-img ${customer === customerConstants.EXO_CUSTOMER1 ? 'edsiderlogo' : customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-logo' : customer === customerConstants.EDF_CUSTOMER2 ? 'ra-logo' : customer === customerConstants.EDF_CUSTOMER3 ? 'cgc-logo' : 'edfocilogo'}`}
                src={logo}
                style={logoStyle}
              />
            </div>
            {/* end::Actions */}
            {isTeacher && <img
              alt="Teacher Logo"
              className="logo usertype-logo usertype-logo-teacher"
              src={teacherImg}
              style={logoStyle}
            />}
            {isStudent && <img
              alt="Student Logo"
              className="logo usertype-logo usertype-logo-student"
              src={studentImg}
              style={logoStyle}
            />}
            {isParent && <img
              alt="Parent Logo"
              className="logo usertype-logo usertype-logo-parent"
              src={parentImg}
              style={logoStyle}
            />}
            {isAdmin && <img
              alt="Admin Logo"
              className="logo usertype-logo usertype-logo-admin"
              src={adminImg}
              style={logoStyle}
            />}
          </div>
          {/* end::Info */}
        </div>

        {/* end::Header Menu Wrapper */}

        {/* begin::Topbar */}
        <div className="topbar" style={{ position: 'relative' }}>
          {/* begin::Notifications */}
          <div className="topbar-item">
            <div
              className="btn btn-icon btn-clean d-flex align-items-center btn-lg px-2 mr-2 notification-icon"
              id="kt_quick_notifications_toggle"
              onClick={toggleNotifications}
              style={{ cursor: 'pointer' }}
            >
              <HiBellAlert className="topbar-icon notification-icon__icon" />
            </div>
          </div>

          {/* Notification Dropdown */}
          <NotificationDropdown
            isOpen={isNotificationOpen}
            onClose={() => setIsNotificationOpen(false)}
          />

          {/* end::Notifications */}
          {/* begin::User */}
          <div className="topbar-item">
            <div
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 profile-icon"
              id="kt_quick_user_toggle"
            >
              <span className="symbol symbol-35 symbol-primary profile-symbol">
                <span className="symbol-label font-size-h5 font-weight-bold">
                  {headerLabelMaker()}
                </span>
              </span>
            </div>
          </div>
          {/* end::User */}
        </div>
        {/* end::Topbar */}
      </div>
      {/* end::Container */}
    </div>
  );
};

export default Header;
